import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @MissingItems
 * @MissingItems
 * @missingItems
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"description","type":"text","placeholder":"Description","label":"Description","width":"130px","addFormOrder":7,"editFormOrder":7,"header":"Description","derivedValue":"description=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"description","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"description","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"volume","type":"text","placeholder":"Volume","label":"Volume","width":"130px","addFormOrder":8,"editFormOrder":8,"header":"Volume","derivedValue":"volume=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"volume","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"volume","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"currentInvenotry","type":"text","placeholder":"Current Invenotry","label":"Current Invenotry","width":"130px","addFormOrder":10,"editFormOrder":10,"header":"Current Invenotry","derivedValue":"currentInvenotry=currentInvenotry=expirationDate=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"currentInvenotry","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"validationRequired":true,"regexPattern":"^[0-9]$","regexData":{"showMinField":false,"minLengthRequired":false,"minLengthText":null,"showMaxField":false,"maxLengthRequired":false,"maxLengthText":null,"alphabetsRequired":false,"showAlphaField":false,"numbersRequired":true,"showNumField":true,"specialCharRequired":false,"showSCharField":false,"specialCharText":null},"textAlign":"Center","show":true,"field":"currentInvenotry","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"requiredInventory","type":"text","placeholder":"Required Inventory","label":"Required Inventory","width":"130px","addFormOrder":13,"editFormOrder":13,"header":"Required Inventory","derivedValue":"requiredInventory=storageUnitSubLocations=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"requiredInventory","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"requiredInventory","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"NeedToOrder","type":"text","placeholder":"Need To Order","label":"Need To Order","width":"130px","addFormOrder":14,"editFormOrder":14,"header":"Need To Order","derivedValue":"NeedToOrder=productQuantityBeingAdded=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"NeedToOrder","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"NeedToOrder","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"facility","type":"text","placeholder":"Facility","label":"Facility","width":"130px","addFormOrder":11,"editFormOrder":11,"header":"Facility","derivedValue":"facility=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"facility","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"facility","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"storageUnit","type":"text","placeholder":"Storage Unit","label":"Storage Unit","width":"130px","addFormOrder":12,"editFormOrder":12,"header":"Storage Unit","derivedValue":"storageUnit=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"storageUnit","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"storageUnit","showOrHideFields":[],"fieldName":"storageUnit","mobile":true,"displayInSettings":true},{"name":"lotId","type":"text","placeholder":"Lot Id","label":"Lot Id","width":"130px","addFormOrder":9,"editFormOrder":9,"header":"Lot Id","derivedValue":"lotId=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"lotId","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"validationRequired":true,"regexPattern":"^.{0,10000}$","regexData":{"showMinField":false,"minLengthRequired":false,"minLengthText":null,"showMaxField":false,"maxLengthRequired":false,"maxLengthText":null,"alphabetsRequired":false,"showAlphaField":false,"numbersRequired":false,"showNumField":false,"specialCharRequired":false,"showSCharField":false,"specialCharText":null},"textAlign":"Center","show":true,"field":"lotId","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"createdByName","type":"Text","placeholder":"Created By","label":"Created By","width":120,"header":"Created By","id":"createdByName","displayinlist":"true","globalSearchField":"false","controllerId":1001,"fieldType":"Text","textAlign":"Center","show":true,"field":"createdByName","mobile":true,"filter":true,"displayInSettings":true},{"name":"updatedByName","type":"Text","placeholder":"Updated By","label":"Updated By","width":120,"header":"Updated By","id":"updatedByName","displayinlist":"true","fieldType":"Text","textAlign":"Center","show":true,"filter":true,"field":"updatedByName","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true}]
 * @[{"name":"description","type":"text","placeholder":"Description","label":"Description","width":"130px","addFormOrder":7,"editFormOrder":7,"derivedValue":"description=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"description","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"},"isAddFormHidden":false,"isEditFormHidden":false},{"name":"volume","type":"text","placeholder":"Volume","label":"Volume","width":"130px","addFormOrder":8,"editFormOrder":8,"derivedValue":"volume=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"volume","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"currentInvenotry","type":"text","placeholder":"Current Invenotry","label":"Current Invenotry","width":"130px","addFormOrder":10,"editFormOrder":10,"derivedValue":"currentInvenotry=currentInvenotry=expirationDate=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"currentInvenotry","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"validationRequired":true,"regexPattern":"^[0-9]$","regexData":{"showMinField":false,"minLengthRequired":false,"minLengthText":null,"showMaxField":false,"maxLengthRequired":false,"maxLengthText":null,"alphabetsRequired":false,"showAlphaField":false,"numbersRequired":true,"showNumField":true,"specialCharRequired":false,"showSCharField":false,"specialCharText":null},"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"requiredInventory","type":"text","placeholder":"Required Inventory","label":"Required Inventory","width":"130px","addFormOrder":13,"editFormOrder":13,"derivedValue":"requiredInventory=storageUnitSubLocations=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"requiredInventory","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"NeedToOrder","type":"text","placeholder":"Need To Order","label":"Need To Order","width":"130px","addFormOrder":14,"editFormOrder":14,"derivedValue":"NeedToOrder=productQuantityBeingAdded=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"NeedToOrder","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"facility","type":"text","placeholder":"Facility","label":"Facility","width":"130px","addFormOrder":11,"editFormOrder":11,"derivedValue":"facility=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"facility","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"storageUnit","type":"text","placeholder":"Storage Unit","label":"Storage Unit","width":"130px","addFormOrder":12,"editFormOrder":12,"derivedValue":"storageUnit=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"storageUnit","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"fieldName":"storageUnit","mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"lotId","type":"text","placeholder":"Lot Id","label":"Lot Id","width":"130px","addFormOrder":9,"editFormOrder":9,"derivedValue":"lotId=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"lotId","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"validationRequired":true,"regexPattern":"^.{0,10000}$","regexData":{"showMinField":false,"minLengthRequired":false,"minLengthText":null,"showMaxField":false,"maxLengthRequired":false,"maxLengthText":null,"alphabetsRequired":false,"showAlphaField":false,"numbersRequired":false,"showNumField":false,"specialCharRequired":false,"showSCharField":false,"specialCharText":null},"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true}]
 * @
 * @
 * @
 *
 *
 *
 */

const OrdersCount = (props) => {
    const [languageData, setLanguageData] = useState();
    const [rolePermission, setRolePermission] = useState();
    const [editSelectedRecord, setEditSelectedRecord] = useState(
        window.location.href.includes("edit")
    );
    const [addSelectedRecord, setAddSelectedRecord] = useState(
        window.location.href.includes("create")
    );
    const [viewSelectedRecord, setViewSelectedRecord] = useState(
        window.location.href.includes("view")
    );
    const [isOpenFormModal, setIsOpenFormModal] = useState(false);
    const [openNewUserModal, setopenNewUserModal] = useState(false);
    const [item, setItem] = useState({});
    const [newFormFields, setNewFormField] = useState([]);
    const [tabType, settabType] = useState("Cart Location");
    const query = new URLSearchParams(location.search);
    const companyId = query.get('comapnyId');
    const params = useParams();
    const companyName = query.get('companyName')
    useEffect(() => {
        let screenPermissions = RolePermissions.screenPermissions("Orders Count");
        if (screenPermissions) {
            setRolePermission(screenPermissions);
        }
    }, []);

    const getDerivedStateFromProps = (props, state) => {
        let storeData = store.getState();
        let languageData =
            storeData &&
                storeData.settingsData &&
                storeData.settingsData.settings &&
                storeData.settingsData.settings.languageTranslation
                ? storeData.settingsData.settings.languageTranslation
                : "";
        return { languageData: languageData };
    };
    // componentDidMount = () => {
    //   //Screen permisions value can be edit,view, no view
    //   let screenPermissions = RolePermissions.screenPermissions('Test');
    //   if (screenPermissions) {
    //     this.setState({
    //       rolePermission: screenPermissions
    //     })
    //   }
    //   // this.getRoleListFromServer()
    // }
    const setData = (props) => {
        let rowData = {};
        if (params.id) {
            rowData["_id"] = JSON.parse(params.id);
            return rowData;
        }
    };

    const getTableFields = (type) => {
        if (type) {
            settabType(type);
        }
        let data = [];
        if (type) {
            data = getMissingItemsTableFields();
        }
        return [...data];
    };

    const getMissingItemsTableFields = () => {
        let roleTypes = [
            {
                label: "All",
                value: null,
            },
            {
                label: "Admin",
                value: "Admin",
            },
            {
                label: "Super Admin",
                value: "Super Admin",
            },
            {
                label: "User",
                value: "User",
            },
        ];
        let StatusTypes = [
            {
                label: "All",
                value: null,
            },
            {
                label: "Active",
                value: "Active",
            },
            {
                label: "Inactive",
                value: "Inactive",
            },
            {
                label: "Pending",
                value: "Pending",
            },
        ];
        let data = [
            // {
            //   textAlign: "center",
            //   width: 47,
            //   field: "Check Box",
            //   label: "Check Box",
            //   fieldType: "multiple",
            //   header: "",
            //   selectionMode: "multiple",
            //   show: true,
            //   mobile: true,
            //   displayInSettings: true,
            // },
            {
                textAlign: "center",
                width: 47,
                field: "Sno",
                label: "SNo",
                header: "S.No",
                filter: false,
                sortable: false,
                placeholder: "Search",
                show: true,
                mobile: true,
                displayInSettings: true,
            },

            {
                name: "storageUnitName",
                type: "text",
                placeholder: "Storage Unit Name",
                label: "Storage Unit Name",
                width: "300px",
                addFormOrder: 7,
                editFormOrder: 7,
                header: "Storage Unit Name",
                derivedValue: "storageUnitName=storageUnitName=undefined",
                capitalizeTableText: true,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "storageUnitName",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                textAlign: "left",
                show: true,
                field: "storageUnitName",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                // fieldType: "Link",
                fieldType: "getRedirect",
                style: {
                    color: "#0e4768",
                    cursor: "pointer",
                    textTransform: "capitalize",
                },
            },
            {
                name: "facilityName",
                type: "text",
                placeholder: "facilityName",
                label: "facilityName",
                width: "240px",
                addFormOrder: 7,
                editFormOrder: 7,
                header: "facility Name",
                derivedValue: "facilityName=facilityName=undefined",
                capitalizeTableText: true,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "facilityName",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                textAlign: "left",
                show: true,
                field: "facilityName",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                // fieldType: "Link",
                style: {
                    color: "#0e4768",
                    cursor: "pointer",
                    textTransform: "capitalize",
                },
            },
            {
                name: "count",
                type: "text",
                placeholder: "count",
                label: "No Of Items",
                width: "120px",
                addFormOrder: 8,
                editFormOrder: 8,
                header: "No Of Items",
                derivedValue: "count=undefined",
                capitalizeTableText: true,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "count",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                textAlign: "center",
                fieldType: 'isCountZero',
                show: true,
                field: "count",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
            },


            // {
            //   show: true,
            //   textAlign: "center",
            //   width: 60,
            //   fieldType: "Actions",
            //   field: "Actions",
            //   header: "Actions",
            //   label: "Actions",
            //   filter: false,
            //   sortable: false,
            //   displayInSettings: true,
            //   displayinServer: "false",
            //   displayinlist: "true",
            //   displayinaddForm: "false",
            //   displayineditForm: "false",
            //   mobile: true,
            // },
        ];
        return data;
    };

    const getFormFields = () => {
        let statusTypes = [
            {
                label: "Active",
                value: "Active",
            },
            {
                label: "Inactive",
                value: "Inactive",
            },
            {
                label: "Pending",
                value: "Pending",
            },
        ];
        return [
            {
                name: "description",
                type: "text",
                placeholder: "Description",
                label: "Description",
                width: "130px",
                addFormOrder: 7,
                editFormOrder: 7,
                derivedValue: "description=undefined",
                capitalizeTableText: true,
                sortable: true,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "description",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                fieldType: "Link",
                style: {
                    color: "#0e4768",
                    cursor: "pointer",
                    textTransform: "capitalize",
                },
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "volume",
                type: "text",
                placeholder: "Volume",
                label: "Volume",
                width: "130px",
                addFormOrder: 8,
                editFormOrder: 8,
                derivedValue: "volume=undefined",
                capitalizeTableText: true,
                sortable: true,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "volume",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "currentInvenotry",
                type: "text",
                placeholder: "Current Invenotry",
                label: "Current Invenotry",
                width: "130px",
                addFormOrder: 10,
                editFormOrder: 10,
                derivedValue:
                    "currentInvenotry=currentInvenotry=expirationDate=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "currentInvenotry",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: true,
                displayOptionsInActions: false,
                globalSearchField: "false",
                controllerId: null,
                validationRequired: true,
                regexPattern: "^[0-9]$",
                regexData: {
                    showMinField: false,
                    minLengthRequired: false,
                    minLengthText: null,
                    showMaxField: false,
                    maxLengthRequired: false,
                    maxLengthText: null,
                    alphabetsRequired: false,
                    showAlphaField: false,
                    numbersRequired: true,
                    showNumField: true,
                    specialCharRequired: false,
                    showSCharField: false,
                    specialCharText: null,
                },
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "requiredInventory",
                type: "text",
                placeholder: "Required Inventory",
                label: "Required Inventory",
                width: "130px",
                addFormOrder: 13,
                editFormOrder: 13,
                derivedValue: "requiredInventory=storageUnitSubLocations=undefined",
                capitalizeTableText: true,
                sortable: true,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "requiredInventory",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "NeedToOrder",
                type: "text",
                placeholder: "Need To Order",
                label: "Need To Order",
                width: "130px",
                addFormOrder: 14,
                editFormOrder: 14,
                derivedValue: "NeedToOrder=productQuantityBeingAdded=undefined",
                capitalizeTableText: true,
                sortable: true,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "NeedToOrder",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "false",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "facility",
                type: "text",
                placeholder: "Facility",
                label: "Facility",
                width: "130px",
                addFormOrder: 11,
                editFormOrder: 11,
                derivedValue: "facility=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "facility",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "storageUnit",
                type: "text",
                placeholder: "Storage Unit",
                label: "Storage Unit",
                width: "130px",
                addFormOrder: 12,
                editFormOrder: 12,
                derivedValue: "storageUnit=undefined",
                capitalizeTableText: true,
                sortable: true,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "storageUnit",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "false",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                fieldName: "storageUnit",
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "lotId",
                type: "text",
                placeholder: "Lot Id",
                label: "Lot Id",
                width: "130px",
                addFormOrder: 9,
                editFormOrder: 9,
                derivedValue: "lotId=undefined",
                capitalizeTableText: true,
                sortable: true,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "lotId",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                validationRequired: true,
                regexPattern: "^.{0,10000}$",
                regexData: {
                    showMinField: false,
                    minLengthRequired: false,
                    minLengthText: null,
                    showMaxField: false,
                    maxLengthRequired: false,
                    maxLengthText: null,
                    alphabetsRequired: false,
                    showAlphaField: false,
                    numbersRequired: false,
                    showNumField: false,
                    specialCharRequired: false,
                    showSCharField: false,
                    specialCharText: null,
                },
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "created",
                type: "date",
                placeholder: "Created",
                label: "Created",
                width: 90,
                derivedValue: "created=undefined",
                actions: [],
                actionsNumber: [],
                id: "created",
                displayinaddForm: "false",
                displayineditForm: "false",
                displayinlist: "true",
                globalSearchField: "false",
                controllerId: null,
                fieldType: "Date",
                dateFormat: "YYYY-MM-DD HH:mm:ss",
                disabled: true,
                show: true,
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: true,
                isEditFormHidden: true,
            },
            {
                name: "updated",
                type: "date",
                placeholder: "Updated",
                label: "Updated",
                width: 90,
                derivedValue: "updated=undefined",
                actions: [],
                actionsNumber: [],
                id: "updated",
                displayinaddForm: "false",
                displayineditForm: "false",
                displayinlist: "true",
                globalSearchField: "false",
                controllerId: null,
                fieldType: "Date",
                dateFormat: "YYYY-MM-DD HH:mm:ss",
                disabled: true,
                show: true,
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: true,
                isEditFormHidden: true,
            },
        ];
    };

    const submit = async (item) => {
        setIsOpenFormModal(true);
        // await this.formModalRef.getRowData(item, 'edit');
    };

    const closeFormModal = async () => {
        setIsOpenFormModal(false);
    };
    // submit1 = item => {
    //   let x = missingItemsFields
    //   let objmissingItems = {}

    //   objmissingItems["_id"] = item[0]["_id"]
    //   for (let x2 of x) {
    //     objmissingItems[x2] = item[0][x2]
    //   }
    //   let formFields = this.getFormFields()

    //   formFields = formFields.filter(y => x.includes(y.name))

    //   this.setState({
    //     openNewUserModal: true,
    //     item: objmissingItems,
    //     newFormFields: formFields
    //   });
    // }

    const cancelReset = async (type) => {
        setopenNewUserModal(false);
        window.location.reload();

        // if (type == "submit") {
        // type == "submit"
        //   ?
        // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
        // }

        // : null;
    };

    const saveDataToServer = async (item, field, value) => {
        let body = item[0];
        body[field] = value;
        let userBody = Object.assign({}, body);
        // this.setState({
        //   isLoading: true
        // });
        if (body) {
            let method, apiUrl;
            method = "PUT";
            apiUrl = `${apiCalls["missingItems"]}/${body._id}`;
            return fetchMethodRequest(method, apiUrl, userBody)
                .then(async (response) => {
                    // let sessionexpired = await localStorage.getItem('sessionexpired')
                    // if (sessionexpired === "true") {
                    //   await this.setState({ sessionExpiryModal: true })
                    // }
                    if (response && response.respCode) {
                        showToasterMessage(response.respMessage, "success");
                    } else if (response && response.errorMessage) {
                        showToasterMessage(response.errorMessage, "error");
                    }
                    // this.setState({
                    //   isLoading: false
                    // });
                })
                .catch((err) => {
                    return err;
                });
        } else {
            return;
        }
    };

    return (
        <span>
            {
                <DataTables
                    {...props}
                    getTableFields={getTableFields}
                    formFields={getFormFields}
                    //
                    addRequired={false
                        // rolePermission && rolePermission == "Edit" ? true : false
                    }
                    editRequired={
                        rolePermission && rolePermission == "Edit" ? true : false
                    }
                    deleteRequired={
                        rolePermission && rolePermission == "Edit" ? true : false
                    }
                    viewRequired={
                        rolePermission && rolePermission == "Edit" ? true : false
                    }
                    // globalSearch={'Display Name/Email'}
                    // type='MissingItems'
                    // apiUrl={apiCalls.MissingItems}
                    // exportRequried={true}
                    printRequried={false}
                    actionsTypes={false}
                    // [
                    // {
                    //   name: "Delete",
                    //   options: [
                    //     {
                    //       label: "Delete",
                    //       value: "Delete",
                    //       show:
                    //         rolePermission && rolePermission == "Edit" ? true : false,
                    //       multiple: true,
                    //     },
                    //   ],
                    // },

                    // {
                    //   'name': 'Block',
                    //   "options": [
                    //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
                    //   ]
                    // },
                    // {
                    //   'name': 'ResetPassword',
                    //   "options": [
                    //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
                    //   ]
                    // },
                    // {
                    //   'name': 'Submit',
                    //   'action': this.submit,
                    //   "options": [
                    //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
                    //   ]
                    // },
                    // {
                    //   name: "newModel",
                    //   action: this.submit1,
                    //   options: [
                    //     { label: "newModel", value: "newModel", show: true, multiple: false }
                    //   ]
                    // }
                    // ]}
                    // addRequried={insertAdd}
                    // editRequired={true}
                    // deleteRequired={true}
                    // viewRequired={true}
                    settingsRequired={false}
                    filterRequired={false}
                    gridRequried={false}
                    exportToCsv={false}
                    dateSearchRequired={false}
                    searchInDateRangeField={""}
                    setData={setData}
                    editSelectedRecord={editSelectedRecord}
                    addSelectedRecord={addSelectedRecord}
                    viewSelectedRecord={viewSelectedRecord}
                    sampleFilePath={filePath["orderItems"]}
                    globalSearch={false}
                    type="OrdersCount"
                    routeTo={apiCalls["ordersCount"]}
                    displayViewOfForm="modal"
                    sideFormLeftOrRight=""
                    // apiResponseKey={apiCalls["missingItems"].toLowerCase()}
                    apiUrl={apiCalls["OrdersCount"]}
                    selectedId={params.id}
                    redirectTo={'orders'}
                    tabType={tabType}
                    frontScreenResponseKey={'OrdersCount'}
                    commonTabTypes={true}
                    selectionMode={true}
                    companyId={companyId}
                    companyName={companyName}
                />
            }
            {isOpenFormModal ? (
                <FormModal
                    // onRef={(ref) => (this.formModalRef = ref)}
                    formType="edit"
                    openFormModal={isOpenFormModal}
                    formFields={formFields}
                />
            ) : null}
            {openNewUserModal ? (
                <NewUserModal
                    openNewUserModal={openNewUserModal}
                    cancelReset={cancelReset}
                    item={item}
                    newFormFields={newFormFields}
                    recordId={item._id}
                    entityType="orderItems"
                    apiUrl={apiCalls["OrdersCount"]}
                />
            ) : null}
        </span>
    );
};

export default OrdersCount;
